/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';

const TitleBar = ({ title, searchResults }) => {
  const { t } = useTranslation('global');

  return (
    <section className='titleBar'>
      <p>
        {t('jobseekerListing.found')}{' '}
        <span>{searchResults?.toLocaleString('uk-UA')}</span>{' '}
        {t('jobseekerListing.cv')}
      </p>
      <h1>
        {
          title
            ? title
            : t('jobseekerListing.cvList')
        }
      </h1>
    </section>
  );
};

export default TitleBar;
